// State
export const state = {
  COLLECTION: 'collection',
  COHORTS: 'cohorts',
  VISIBLE_COHORTS: 'visibleCohorts',
  IS_LOADING: 'isLoading',
  OUTCOME_VARIABLES: 'outcomeVariables',
  DATA: 'data',
  RAW_DATA: 'rawData',
  DETAILED_VIEW: 'detailedView',
  PVAL_THRESHOLD: 'pvalThreshold',
  ANOVA_PVALS: 'anovaPvals',
  ANOVA_PVALS_INPUT: 'anovaPvalsInput',
  SCREEN_RESIZE: 'screenResize',
  SELECTED_ANALYSIS_MODE: 'selectedAnalysisMode',
};

// Getters
export const getters = {};

// Mutations
export const mutations = {
  SET_COHORTS: 'setCohorts',
  SET_VISIBLE_COHORTS: 'setVisibleCohorts',
  SET_LOADING: 'setLoading',
  SET_COLLECTION: 'setCollection',
  SET_OUTCOME_VARIABLES: 'setOutcomeVariables',
  SET_DATA: 'setData',
  SET_RAW_DATA: 'setRawData',
  SET_DETAILED_VIEW: 'setDetailedView',
  SET_PVAL_THRESHOLD: 'setPvalThreshold',
  RESET_PVAL_THRESHOLD: 'resetPvalThreshold',
  SET_ANOVA_PVALS: 'setAnovaPvals',
  SET_ANOVA_PVALS_INPUT: 'setAnovaPvalsInput',
  SET_SCREEN_RESIZE: 'setScreenResize',
  SET_ANALYSIS_MODE: 'setAnalysisMode',
};

// Actions
export const actions = {
  FETCH_COLLECTION: 'fetchCollection',
  FETCH_COHORTS: 'fetchCohort',
  ANALYZE_COHORTS: 'analyzeCohorts',
  SET_VISIBLE_COHORTS: 'setVisibleCohorts',
  SET_OUTCOME_VARIABLES: 'setOutcomeVariables',
  CLEAR_DATA: 'clearData',
  FETCH_DATA: 'fetchData',
  FETCH_RAW_DATA: 'fetchRawData',
  SET_DETAILED_VIEW: 'setDetailedView',
  SET_PVAL_THRESHOLD: 'setPvalThreshold',
  RESET_PVAL_THRESHOLD: 'resetPvalThreshold',
  SET_COHORT_SUBJECTS: 'setCohortSubjects',
  SAVE_COHORT_DISPLAY_PREFS: 'saveCohortDisplayPrefs',
  SET_SCREEN_RESIZE: 'setScreenResize',
  SET_ANALYSIS_MODE: 'setAnalysisMode',
};
